import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function OurProductsSection() {
    const { t } = useTranslation();

    return (
        <section className="relative py-16 bg-gray-50">
            <div className="container mx-auto px-4">
                <h2 className="text-4xl font-bold text-[#E56820] border-b-4 border-[#E56820] w-fit mb-6 mx-auto">
                    {t("Our Products")}
                </h2>
                <div className="flex flex-col gap-8">
                    <div className="bg-white shadow-lg rounded-lg p-6 text-lg leading-relaxed">
                        <p className="mt-4">{t("products_text")}</p>
                    </div>
                    <div className="f-col flex items-center gap-6">
                        <img
                            src={require("../../assets/product/DSC00015.JPG")}
                            alt={t("product_image")}
                            className="w-full h-[30rem] object-cover rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105"
                        />
                        <img
                            src={require("../../assets/product/DSC00024.JPG")}
                            alt={t("granules_image")}
                            className="w-full h-[30rem] object-cover rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105"
                        />
                    </div>
                    <Link
                        to="/product"
                        className="w-fit mx-auto bg-[#e56820] text-white px-[30px] py-2 rounded font-bold"
                    >
                        {t("Explore Products")}
                    </Link>
                </div>
            </div>
        </section>
    );
}
